export const GUESS_POWER_TIER = 77;
